import React, { useState } from "react";
import LayersGroup from "./LayersGroup";
import LayersCard from "./LayersCard";

const FolderLayout = ({
  fileStructure,
  setLayerName,
  setLayersThatWereSwitchedNames,
  setSwitchIsOn,
  setShowTooltip,
  setLayerOpacity,
  setBoundingBox,
  setButtonOn,
  checkedAll,
  setCheckedAll,
  layersThatWereSwitchedNames,
  activeLayers,
  setActiveLayers,
  searchTerm,
}) => {
  return (
    <>
      {Object.keys(fileStructure).map((groupName, index) => {
        let isLayer = fileStructure[groupName].Name ? true : false;

        // console.log(isLayer, "isLayer");
        return isLayer ? (
          <LayersCard
            jsonFile={fileStructure[groupName]}
            key={index}
            prevGroupName={groupName}
            fullPath={groupName} // Initialize full path
            objectContent={fileStructure}
            setLayerName={setLayerName}
            setLayersThatWereSwitchedNames={setLayersThatWereSwitchedNames}
            setSwitchIsOn={setSwitchIsOn}
            setShowTooltip={setShowTooltip}
            setLayerOpacity={setLayerOpacity}
            setBoundingBox={setBoundingBox}
            setButtonOn={setButtonOn}
            checkedAll={checkedAll}
            setCheckedAll={setCheckedAll}
            layersThatWereSwitchedNames={layersThatWereSwitchedNames}
            activeLayers={activeLayers}
            setActiveLayers={setActiveLayers}
            searchTerm={searchTerm}
          />
        ) : (
          <LayersGroup
            jsonFile={fileStructure[groupName]}
            key={index}
            prevGroupName={groupName}
            fullPath={groupName} // Initialize full path
            setLayerName={setLayerName}
            setLayersThatWereSwitchedNames={setLayersThatWereSwitchedNames}
            setSwitchIsOn={setSwitchIsOn}
            setShowTooltip={setShowTooltip}
            setLayerOpacity={setLayerOpacity}
            setBoundingBox={setBoundingBox}
            setButtonOn={setButtonOn}
            checkedAll={checkedAll}
            setCheckedAll={setCheckedAll}
            layersThatWereSwitchedNames={layersThatWereSwitchedNames}
            activeLayers={activeLayers}
            setActiveLayers={setActiveLayers}
            searchTerm={searchTerm}
          />
        );
      })}
    </>
  );
};

export default FolderLayout;